<div class="row recipes-buttons">
    <div class="col-md-12 text-right">
        <button
                type="button"
                class="btn btn-primary btn-icon-text"
                (click)="openFilter($event)"
        >
            <i class="ti-filter btn-icon-prepend"></i>
            {{ 'filter_recipes' | localise }}
        </button>
    </div>
</div>

<div class="row">
    <div class="col-md-4 column-recipe" *ngFor="let item of recipes">
        <div
                (click)="router.navigate(['meals'])"
                class="card-img-top animated fadeIn"
                *ngIf="item.main_image"
                [lazyLoad]="constants.imagesUrl() + '/images/850x500/' + item.main_image.type + '/' + item.main_image.name + '/'">
            <div class="recipe-title">
                <span>{{ item.recipe.title }}</span>
            </div>
        </div>
    </div>
</div>

<button
        *ngIf="hasMore"
        type="button"
        class="btn btn-primary btn-icon-text load-more"
        (click)="loadMore()">
    <i class="ti-reload btn-icon-prepend"></i>
    {{ 'load_more' | localise }}
</button>
